<template>
  <v-card
    loader-height="8"
    :loading="admin.projectSettingsLoading"
    :disabled="admin.projectSettingsLoading"
    min-width="600"
    :min-height="minCardHeight"
    v-show="admin.selectedProjectSetting != null"
  >
    <v-dialog v-model="showConfirmationDialog" max-width="450">
      <v-card>
        <v-card-title
          ><v-icon class="mr-2" color="yellow darken-2"> mdi-alert </v-icon
          >CONFIRM</v-card-title
        >
        <v-card-text class="text-h5">
          Delete Project Setting ({{ id }})?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="deleteProjectSetting">
            <v-icon> mdi-check-bold </v-icon>
          </v-btn>
          <v-btn
            color="error lighten-1"
            @click="showConfirmationDialog = false"
          >
            <v-icon> mdi-cancel </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar color="blue lighten-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.detailIcon }}</v-icon>
    </v-toolbar>
    <v-card-text v-show="admin.selectedProjectSetting == null"></v-card-text>
    <v-card-text v-show="admin.selectedProjectSetting != null">
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> Setting saved </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field disabled v-model="id" label="ID" readonly></v-text-field>
        <v-autocomplete
          :items="admin.attributeList"
          label="Attribute"
          outlined
          item-text="name"
          item-value="id"
          v-model="attributeId"
          :rules="validation.selection"
          autofocus
        ></v-autocomplete>
        <v-text-field
          v-model="label"
          :rules="validation.length50"
          label="Label"
          required
        ></v-text-field>
        <v-text-field v-model="valueSuffix" label="Value Suffix"></v-text-field>
        <v-checkbox
          color="blue darken-2"
          v-model="published"
          label="Published"
        ></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions v-show="admin.selectedProjectSetting != null">
      <v-spacer />
      <v-btn
        dark
        color="blue darken-2"
        @click="saveProjectSetting"
        :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="cancelCreation">cancel</v-btn>
      <v-btn
        v-show="!isNaN(id)"
        icon
        color="error"
        @click="confirmDeleteSetting"
        ><v-icon>mdi-trash-can</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    data() {
      return {
        showSaveOverlay: false,
        showConfirmationDialog: false,
        valid: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      tabName: {
        get() {
          let tabName = 'Edit Setting';
          if (
            this.admin.selectedProjectSetting &&
            this.admin.selectedProjectSetting.id != 'new'
          ) {
            tabName = `Edit Setting ${this.admin.selectedProjectSetting.label}`;
          } else if (
            this.admin.selectedProjectSetting &&
            this.admin.selectedProjectSetting.id == 'new'
          ) {
            tabName = 'Add New Setting';
          }
          return tabName;
        }
      },
      id: {
        get() {
          return this.admin.selectedProjectSetting?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProjectSetting',
            property: 'id',
            value: value
          });
        }
      },
      projectId: {
        get() {
          return this.admin.selectedProjectSetting?.projectId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProjectSetting',
            property: 'projectId',
            value: Number(value)
          });
        }
      },
      attributeId: {
        get() {
          return this.admin.selectedProjectSetting?.attributeId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProjectSetting',
            property: 'attributeId',
            value: Number(value)
          });
        }
      },
      label: {
        get() {
          return this.admin.selectedProjectSetting?.label;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProjectSetting',
            property: 'label',
            value: value
          });
        }
      },
      valueSuffix: {
        get() {
          return this.admin.selectedProjectSetting?.valueSuffix;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProjectSetting',
            property: 'valueSuffix',
            value: value
          });
        }
      },
      published: {
        get() {
          return this.admin.selectedProjectSetting?.published;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProjectSetting',
            property: 'published',
            value: Boolean(value)
          });
        }
      }
    },
    methods: {
      /**
       * Cancels upsert of a project
       */
      cancelCreation() {
        this.$store.commit('admin/setSelectedProjectSetting', null);
      },
      /**
       * Saves the project currently being edited
       */
      saveProjectSetting() {
        this.$store.dispatch('admin/saveSelectedProjectSetting').then(() => {
          this.showSaveOverlay = true;
          // refresh project list
          this.$store.dispatch('admin/getProjectSettingList');
          setTimeout(() => {
            this.showSaveOverlay = false;
          }, 1500);
        });
      },
      /**
       * Show confirm dialog
       */
      confirmDeleteSetting() {
        this.showConfirmationDialog = true;
      },
      /**
       * Deletes a a product setting
       */
      deleteProjectSetting() {
        this.$store.dispatch('admin/deleteProjectSetting', this.id).then(() => {
          this.$store.dispatch('admin/getProjectSettingList');
          this.showConfirmationDialog = false;
          this.$store.commit('admin/setSelectedProjectSetting', null);
        });
      }
    }
  };
</script>

<style scoped></style>
